module.exports = __webpack_public_path__ + "img/xbox.b0913b03.png";